import {
  KatButton,
  KatDateRangePicker,
  KatDropdown,
  KatIcon,
  KatPopover,
} from "@amzn/katal-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { TestStatus } from "src/api/interfaces/nest";
import "./index.css";

interface NestHistoryDateFilterProps {
  dateFrom?: Date;
  dateTo?: Date;
  status?: TestStatus;
  onDateRangeChange: (from?: Date, to?: Date) => void;
  onStatusChange: (value?: TestStatus) => void;
}

export function NestHistoryDateFilter({
  dateFrom,
  dateTo,
  status,
  onDateRangeChange,
  onStatusChange,
}: NestHistoryDateFilterProps) {
  const { t } = useTranslation();

  const statusOptions = Object.values(TestStatus).map((s) => ({
    name: t(`nest_status_${s.toLocaleLowerCase()}`),
    value: s,
  }));

  return (
    <KatPopover triggerType="click" position="bottom">
      <KatIcon
        slot="trigger"
        name="filter"
        size="small"
        className="nest-filter-trigger"
      />
      <div className="nest-filter-content">
        <div className="nest-filter-row">
          <KatDateRangePicker
            startLabel={t("nest_history_dateFrom")}
            endLabel={t("nest_history_dateTo")}
            startValue={dateFrom}
            endValue={dateTo}
            onChange={(e) =>
              onDateRangeChange(
                e.detail.startDate ? new Date(e.detail.startDate) : undefined,
                e.detail.endDate ? new Date(e.detail.endDate) : undefined
              )
            }
          />
          {(dateFrom || dateTo) && (
            <KatIcon
              name="close"
              size="small"
              className="nest-filter-clear"
              onClick={() => onDateRangeChange(undefined, undefined)}
            />
          )}
        </div>
        <div className="nest-filter-row">
          <KatDropdown
            className="nest-filter-dropdown"
            label={t("nest_history_status")}
            options={statusOptions}
            value={status}
            onChange={(e) => onStatusChange(e.detail.value as TestStatus)}
          />
          {status && (
            <KatIcon
              name="close"
              size="small"
              className="nest-filter-clear"
              onClick={() => onStatusChange(undefined)}
            />
          )}
        </div>
        <KatButton
          variant="secondary"
          size="small"
          onClick={() => {
            onDateRangeChange(undefined, undefined);
            onStatusChange(undefined);
          }}
        >
          {t("nest_history_clearFilter")}
        </KatButton>
      </div>
    </KatPopover>
  );
}
